//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { PackageDefinitionDisplayItem } from './PackageDefinitionDisplayItem';
import { TeacherNameDisplayItem } from './TeacherNameDisplayItem';
import { StudentNameDisplayItem } from './StudentNameDisplayItem';
import { TransactionDisplayItem } from './TransactionDisplayItem';
import { CalendarEventDisplayItem } from './CalendarEventDisplayItem';
import { PackageLedgerEntryType } from './Enums';

export class PackageMinutesDisplayItem extends ItemBase {
    ID: string | null = null;
    PackageDefinitionID: string | null = null;
    SourcePackageMinutesID: string | null = null;
    TeacherID: string | null = null;
    StudentID: string | null = null;
    PackageDefinition: PackageDefinitionDisplayItem | null = null;
    Teacher: TeacherNameDisplayItem | null = null;
    Student: StudentNameDisplayItem | null = null;
    CreatedDate: string = "1970-01-01T00:00:00";
    ExpiryDate: string | null = null;
    EntryType: PackageLedgerEntryType = PackageLedgerEntryType.Purchase;
    TransactionID: string | null = null;
    Transaction: TransactionDisplayItem | null = null;
    Minutes: number = 0;
    EventID: string | null = null;
    Event: CalendarEventDisplayItem | null = null;
    BalanceMinutes: number = 0;
    NextPackageUsage: string | null = null;

    constructor(initializer?: Partial<PackageMinutesDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "PackageMinutesDisplayItem";
}
